export default __webpack_public_path__ + "static/media/286.56be0e78.jpg";